// The API base is derived from the page's own origin so the frontend always
// talks to its backend same-origin. The platform gateway rewrites Origin
// headers across its domains, which breaks credentialed CORS — same-origin
// avoids CORS entirely. REACT_APP_BACKEND_URL stays in .env as the canonical
// public URL reference for external tooling.
export const BACKEND = window.location.origin;
export const API = `${BACKEND}/api`;
